import { WageAndTravelReimbursementRequestStatus } from "@nkr/enums/watr-reimbursement-request-status";

export interface IActionCenterWatrRequestWeek {
    name: string,
    requestId: number,
    weekRequested: number[],
    status: WageAndTravelReimbursementRequestStatus,
    createdDateTime: Date,
    lastUpdated: Date,
    alias: string,
}